import { Breadcrumb, Icon, Stack } from '@servicetitan/design-system';
import strings from '../../strings';

type EditContactDrawerPageHeaderProps = {
  customerName: string;
  onBackClick: () => void;
};

const EditContactDrawerPageHeader = ({
  customerName,
  onBackClick,
}: EditContactDrawerPageHeaderProps) => {
  return (
    <div>
      <Breadcrumb className='fw-normal m-b-2'>
        <Breadcrumb.Link
          label={strings.labels.breadCrumbs.contactMethods}
          onClick={onBackClick}
        />
        <Breadcrumb.Link label={strings.labels.breadCrumbs.editContacts} />
      </Breadcrumb>
      <Stack alignItems='center' spacing={1}>
        <Icon
          className='cursor-pointer'
          name='arrow_back'
          aria-label={strings.labels.backToView}
          onClick={onBackClick}
        />
        <div className='drawer-header__title'>{`Edit Contacts - ${customerName}`}</div>
      </Stack>
    </div>
  );
};

export default EditContactDrawerPageHeader;
